import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { backendApiUrl, backendBaseUrl, vLearnApiUrl } from '../../api/config';
const coursesBaseUrl = `${backendApiUrl}?`;
const attendanceBaseUrl = `${vLearnApiUrl}/attendance`;
// const attendanceBaseUrl = `https://staging-api.herovired.com/v1/learner-management/learners/attendance`;
const weeklyOverviewBaseUrl = `${backendBaseUrl}/webservice/rest/server.php?`;
const liveClassBaseUrl = `${backendBaseUrl}/webservice/rest/server.php?`;
const assignmentBaseUrl = `${backendBaseUrl}/webservice/rest/server.php?`;
// const attendanceDetailsBaseUrl = 'https://staging-api.herovired.com/v1/learner-management/learners/attendance/details?size=0&offset=-1';
const attendanceDetailsBaseUrl = `${vLearnApiUrl}/attendance/details`;
// const attendanceDetailsBaseUrl = `${vLearnApiUrl}/attendance/details`;

export const getAttendanceDetails = createAsyncThunk(
  'learnerData/attendanceDetails',
  async (values) => {
    try {
      // console.log("COURSEAPI", values);
      let attendanceDetailsParams = {
        learnerId: values.learnerId,
        programId: values.programId
      };

      // console.log("attendance details params", attendanceDetailsParams);

      let options = {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(attendanceDetailsParams)
      };

      // console.log("attendance details options", options);

      // console.log("attendance details url", attendanceDetailsBaseUrl);

      const response = await fetch(
        attendanceDetailsBaseUrl +
          `?courseId=${
            values?.courseId == 'all' ? null : values?.courseId
          }&status=${
            values?.statusId == 'all' ? null : values?.statusId
          }&classType=${values?.classType == 'all' ? null : values?.classType}`,
        options
      );

      // console.log("attendance details reponse", response);

      if (response.status == '200') {
        const data = await response.json();
        // console.log("attendance details data", data);
        return data;
      } else {
        throw new Error('data not available');
      }
    } catch (error) {
      // console.log("attendance details error",error);
      throw error;
    }
  }
);

export const getGradeDetails = createAsyncThunk(
  'learnerData/gradeDetails',
  async (values) => {
    try {
      // let gradeDetailsUrl = `https://staging-api.herovired.com/v1/learner-management/learners/grades/course/metrics/lp/${values.programId}/user/${values.learnerId}`

      // let gradeDetailsUrl = `https://staging-api.herovired.com/v1/learner-management/learners/grades/course/metrics/lp/96/user/4186`;
      let gradeDetailsUrl = `${vLearnApiUrl}/grades/details/${values.programId}/users/${values.learnerId}`;

      // console.log("grade details url", gradeDetailsUrl);

      const response = await fetch(gradeDetailsUrl);

      // console.log("grade details reponse", response);

      if (response.status == '200') {
        const data = await response.json();
        return data.data;
      } else {
        throw new Error('data not available');
      }
    } catch (error) {
      // console.log("grade details error",error);
      throw error;
    }
  }
);

export const getWeeklyOverviewData = createAsyncThunk(
  'learnerData/weeklyOverview',
  async (values) => {
    try {
      let weeklyOverviewParams = {
        moodlewsrestformat: 'json',
        wsfunction: 'local_apis_get_week_overview',
        programid: values.programId,
        wstoken: values.token
      };

      // console.log("weekly overview params", weeklyOverviewParams);

      let weeklyOverviewUrl =
        weeklyOverviewBaseUrl + new URLSearchParams(weeklyOverviewParams);

      // console.log("weekly overview url", weeklyOverviewUrl);

      const response = await fetch(weeklyOverviewUrl);

      // console.log("weekly overview response", response);

      if (response.ok) {
        const data = await response.json();

        // console.log("weekly overview response data", data);

        if (data.liveclasses) return data;
        else throw new Error('data unavailable');
      } else {
        throw new Error('service unavailable');
      }
    } catch (error) {
      // console.log("get weekly overview error", err);
      throw error;
    }
  }
);

export const getAttendanceData = createAsyncThunk(
  'learnerData/attendance',
  async (values) => {
    try {
      let attendanceParams = {
        learnerId: values.learnerId,
        programId: values.programId
      };

      let options = {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify(attendanceParams)
      };

      const response = await fetch(attendanceBaseUrl, options);
      if (response.status == '200') {
        const data = await response.json();

        return data;
      } else {
        throw new Error('data not available');
      }
    } catch (err) {
      // console.log("attendance error", err);
      throw new Error('data not available');
    }
  }
);

export const getGradesData = createAsyncThunk(
  'learnerData/grades',
  async (values) => {
    try {
      // let gradesUrl = `https://staging-api.herovired.com/v1/learner-management/learners/grades/program/metrics/lp/${values.programId}/user/${values.learnerId}`;

      // let gradesUrl = `https://staging-api.herovired.com/v1/learner-management/learners/grades/program/metrics/lp/38/user/2775`;
      let gradesUrl = `${vLearnApiUrl}/grades/${values.programId}/users/${values.learnerId}`;

      // console.log("grades url", gradesUrl);

      const response = await fetch(gradesUrl);

      // console.log("grades reponse", response);

      if (response.status == '200') {
        const data = await response.json();
        // console.log("grades data",data);
        return data.data;
      } else {
        throw new Error('data not available');
      }
    } catch (err) {
      // console.log("grades error", err);
      throw new Error('data not available');
    }
  }
);

export const getCourseData = createAsyncThunk(
  'learnerData/course',
  async (values) => {
    try {
      let courseParams = {
        moodlewsrestformat: 'json',
        wsfunction: 'block_programs_get_learningpath_courses',
        lpid: values.programId,
        wstoken: values.token
      };

      // console.log("course params", courseParams);

      let courseUrl = coursesBaseUrl + new URLSearchParams(courseParams);

      // console.log("course url", courseUrl);

      const response = await fetch(courseUrl);

      // console.log("course reponse", response);

      if (response.status == '200') {
        const data = await response.json();

        if (data.courses) {
          return data;
        } else {
          throw new Error('data unavailable');
        }
      } else {
        throw new Error('data unavailable');
      }
    } catch (err) {
      // console.log("attendance error", err);
      throw new Error('data unavailable');
    }
  }
);

export const getLiveClassData = createAsyncThunk(
  'learnerData/liveClass',
  async (values, thunkAPI) => {
    try {
      const token = 'a92c251ec7924cc542f4fde458a79767';
      const pid = 17;

      let liveClassDataParams = {
        moodlewsrestformat: 'json',
        wstoken: values.token,
        wsfunction: 'local_apis_get_live_classes_content',
        programid: values.programId
      };

      // console.log("live class params", liveClassDataParams);

      let liveClassDataUrl =
        liveClassBaseUrl + new URLSearchParams(liveClassDataParams);

      // console.log("live class url", liveClassDataUrl);

      const response = await fetch(liveClassDataUrl);

      // console.log("live class response", response);

      if (response.ok) {
        const data = await response.json();

        // console.log("live class data", data);

        if (data.exception) {
          throw new Error(data.message);
        } else {
          return data;
        }
      } else {
        throw new Error('service not available');
      }
    } catch (err) {
      throw new Error('data not available');
    }
  }
);

export const getAssignmentData = createAsyncThunk(
  'learnerData/assignment',
  async (values, thunkAPI) => {
    try {
      const token = 'a92c251ec7924cc542f4fde458a79767';
      const pid = 5;

      let assignmentDataParams = {
        moodlewsrestformat: 'json',
        wstoken: values.token,
        wsfunction: 'local_apis_get_assignment_content',
        programid: values.programId
      };

      // console.log("assignment params", assignmentDataParams);

      let assignmentDataUrl =
        assignmentBaseUrl + new URLSearchParams(assignmentDataParams);

      // console.log("assignment url", assignmentDataUrl);

      const response = await fetch(assignmentDataUrl);

      // console.log("assignment response", response);

      if (response.ok) {
        const data = await response.json();

        // console.log("assignment data", data);

        if (data.exception) {
          throw new Error(data.message);
        } else {
          return data;
        }
      } else {
        throw new Error('service not available');
      }
    } catch (err) {
      throw new Error('data not available');
    }
  }
);

const initialState = {
  attendance: {
    data: null,
    currentAttendance: null,
    pending: false,
    receivedData: false,
    error: null
  },
  attendanceDetails: {
    data: null,
    pending: false,
    receivedData: false,
    error: null,
    uniqueCourseData: []
  },
  courses: {
    data: null,
    pending: false,
    receivedData: false,
    error: null
  },
  grade: {
    data: null,
    pending: false,
    receivedData: false,
    error: null
  },
  gradeDetails: {
    data: null,
    pending: false,
    receivedData: false,
    error: null
  },
  liveClasses: {
    data: [],
    receivedData: false,
    error: null
  },
  assignment: {
    data: [],
    receivedData: false,
    error: null
  },
  weeklyOverview: {
    data: {
      liveclasses: [],
      assignments: []
    },
    receivedData: false,
    error: null
  },
  attendanceAndCoursesStatus: false
};

const learnerDataSlice = createSlice({
  name: 'learnerData',
  initialState,
  reducers: {},
  extraReducers: {
    [getAttendanceData.pending]: (state) => {
      state.attendance.receivedData = false;
      state.attendance.isLoading = true;
      state.attendance.error = null;
      state.attendance.data = null;
    },
    [getAttendanceData.fulfilled]: (state, action) => {
      state.attendance.receivedData = true;
      state.attendance.isLoading = false;
      state.attendance.error = null;
      state.attendance.data = action.payload;

      if (action.payload.attendance.mendatoryClasses.total == 0) {
        state.attendance.currentAttendance = 0;
      } else {
        state.attendance.currentAttendance =
          (action.payload.attendance.mendatoryClasses.attended /
            action.payload.attendance.mendatoryClasses.total) *
          100;
      }

      if (state.courses.receivedData) state.attendanceAndCoursesStatus = true;
    },
    [getAttendanceData.rejected]: (state, action) => {
      state.attendance.receivedData = true;
      state.attendance.isLoading = false;
      state.attendance.error = action.error.message;
      state.attendance.data = null;
    },
    [getCourseData.pending]: (state) => {
      state.courses.receivedData = false;
      state.courses.isLoading = true;
      state.courses.error = null;
      state.courses.data = null;
    },
    [getCourseData.fulfilled]: (state, action) => {
      state.courses.receivedData = true;
      state.courses.isLoading = false;
      state.courses.error = null;
      state.courses.data = action.payload.courses;
      if (state.attendance.receivedData)
        state.attendanceAndCoursesStatus = true;
    },
    [getCourseData.rejected]: (state, action) => {
      state.courses.receivedData = true;
      state.courses.isLoading = false;
      state.courses.error = action.error.message;
      state.courses.data = null;
    },
    [getLiveClassData.pending]: (state) => {
      state.liveClasses.receivedData = false;
      state.liveClasses.isLoading = true;
      state.liveClasses.error = null;
      state.liveClasses.data = [];
    },
    [getLiveClassData.fulfilled]: (state, action) => {
      state.liveClasses.receivedData = true;
      state.liveClasses.isLoading = false;
      state.liveClasses.error = null;
      state.liveClasses.data = action.payload;
    },
    [getLiveClassData.rejected]: (state, action) => {
      state.liveClasses.receivedData = true;
      state.liveClasses.isLoading = false;
      state.liveClasses.error = action.error.message;
      state.liveClasses.data = [];
    },
    [getAssignmentData.pending]: (state) => {
      state.assignment.receivedData = false;
      state.assignment.isLoading = true;
      state.assignment.error = null;
      state.assignment.data = [];
    },
    [getAssignmentData.fulfilled]: (state, action) => {
      state.assignment.receivedData = true;
      state.assignment.isLoading = false;
      state.assignment.error = null;
      state.assignment.data = action.payload;
    },
    [getAssignmentData.rejected]: (state, action) => {
      state.assignment.receivedData = true;
      state.assignment.isLoading = false;
      state.assignment.error = action.error.message;
      state.assignment.data = [];
    },
    [getWeeklyOverviewData.pending]: (state) => {
      state.weeklyOverview.receivedData = false;
      state.weeklyOverview.isLoading = true;
      state.weeklyOverview.error = null;
      state.weeklyOverview.data = {
        liveclasses: [],
        assignments: []
      };
    },
    [getWeeklyOverviewData.fulfilled]: (state, action) => {
      state.weeklyOverview.receivedData = true;
      state.weeklyOverview.isLoading = false;
      state.weeklyOverview.error = null;
      state.weeklyOverview.data = action.payload;
    },
    [getWeeklyOverviewData.rejected]: (state, action) => {
      state.weeklyOverview.receivedData = true;
      state.weeklyOverview.isLoading = false;
      state.weeklyOverview.error = action.error.message;
      state.weeklyOverview.data = {
        liveclasses: [],
        assignments: []
      };
    },
    [getAttendanceDetails.pending]: (state, action) => {
      state.attendanceDetails.data = null;
      state.attendanceDetails.pending = true;
      state.attendanceDetails.receivedData = false;
      state.attendanceDetails.error = null;
    },
    [getAttendanceDetails.fulfilled]: (state, action) => {
      state.attendanceDetails.data = action.payload;
      state.attendanceDetails.pending = false;
      state.attendanceDetails.receivedData = true;
      state.attendanceDetails.error = null;
      const { courseId, classType, statusId } = action?.meta?.arg;
      if (courseId == 'all' && classType == 'all' && statusId == 'all') {
        const uniqueMap = new Map();
        action.payload?.forEach((item) => {
          uniqueMap.set(item.courseId, item);
        });
        state.attendanceDetails.uniqueCourseData = Array.from(
          uniqueMap.values()
        );
      }
    },
    [getAttendanceDetails.rejected]: (state, action) => {
      state.attendanceDetails.data = null;
      state.attendanceDetails.pending = false;
      state.attendanceDetails.receivedData = false;
      state.attendanceDetails.error = action.error.message;
    },
    [getGradeDetails.pending]: (state) => {
      state.gradeDetails.data = null;
      state.gradeDetails.pending = true;
      state.gradeDetails.receivedData = false;
      state.gradeDetails.error = null;
    },
    [getGradeDetails.fulfilled]: (state, action) => {
      state.gradeDetails.data = action.payload;
      state.gradeDetails.pending = false;
      state.gradeDetails.receivedData = true;
      state.gradeDetails.error = null;
    },
    [getGradeDetails.rejected]: (state, action) => {
      state.gradeDetails.data = null;
      state.gradeDetails.pending = false;
      state.gradeDetails.receivedData = false;
      state.gradeDetails.error = action.error.message;
    },
    [getGradesData.pending]: (state) => {
      state.grade.data = null;
      state.grade.pending = true;
      state.grade.receivedData = false;
      state.grade.error = null;
    },
    [getGradesData.fulfilled]: (state, action) => {
      state.grade.data = action.payload;
      state.grade.pending = false;
      state.grade.receivedData = true;
      state.grade.error = null;
    },
    [getGradesData.rejected]: (state, action) => {
      state.grade.data = null;
      state.grade.pending = false;
      state.grade.receivedData = false;
      state.grade.error = action.error.message;
    }
  }
});

export default learnerDataSlice.reducer;
